import { gql } from '@apollo/client';
import type { CommonConfigType } from '../../common-config/graphql/commonConfigQueries';

export const POD_CAPTURE_CONFIG_KEY = 'pod.capture.config';

export interface PodCaptureCameraItemInput {
    cameraImgUrl?: string | null;
    topTips?: string;
    firstAttributedTips?: string;
    secondAttributedTips?: string;
    key?: string;
    title?: string;
    skippable?: boolean;
    dialogTitle?: string;
    dialogAttributedTips?: string;
    nodeName?: string;
    sequenceLabel?: string;
}

export interface PodCaptureClientConfigInput {
    camera?: PodCaptureCameraItemInput[];
}

export interface SavePodCaptureConfigAllLangsResponse {
    savePodCaptureConfigAllLangs: CommonConfigType;
}

export interface SavePodCaptureConfigAllLangsVariables {
    input: PodCaptureConfigAllLangsInput;
}

export interface PodCaptureConfigPerModeAllLangsInput {
    zh: PodCaptureClientConfigInput;
    en: PodCaptureClientConfigInput;
    es: PodCaptureClientConfigInput;
}

export interface PodCaptureConfigAllLangsInput {
    cameraDoorNumber: PodCaptureConfigPerModeAllLangsInput;
    cameraDoorSubNumber: PodCaptureConfigPerModeAllLangsInput;
}

export const SAVE_POD_CAPTURE_CONFIG_ALL_LANGS = gql`
    mutation SavePodCaptureConfigAllLangsV2($input: PodCaptureConfigAllLangsInput!) {
        savePodCaptureConfigAllLangs(input: $input) {
            id
            configKey
            configValue
            configType
            isActive
            updatedAt
        }
    }
`;
